import UsernameRecoverySuccess from './UsernameRecoverySuccess'
export default UsernameRecoverySuccess
